import { useCallback } from "react"
import { Machine } from "xstate"
import { useMachine } from "@xstate/react"
import { createContainer } from "unstated-next"

const toggleMachine = Machine({
    id: "flow",
    initial: "connectWallet",
    context: {
        retries: 0,
    },
    states: {
        connectWallet: {
            on: {
                CONNECT_ACTION: "home",
            },
        },
        home: {
            on: {
                STAKE_ACTION: "stake",
                UNSTAKE_ACTION: "unstake",
                DISCONNECT_ACTION: "connectWallet",
            },
        },
        stake: {
            on: {
                CLOSE_ACTION: "home",
                DISCONNECT_ACTION: "connectWallet",
            },
        },
        unstake: {
            on: {
                CLOSE_ACTION: "home",
                DISCONNECT_ACTION: "connectWallet",
            },
        },
    },
})

export const XState = createContainer(useFlow)

function useFlow() {
    const [current, send] = useMachine(toggleMachine)
    const xConnectWallet = useCallback(() => send("CONNECT_ACTION"), [send])
    const xDisconnectWallet = useCallback(() => send("DISCONNECT_ACTION"), [send])
    const xClose = useCallback(() => send("CLOSE_ACTION"), [send])
    const xStake = useCallback(() => send("STAKE_ACTION"), [send])
    const xUnStake = useCallback(() => send("UNSTAKE_ACTION"), [send])

    return {
        state: current,
        actions: {
            xConnectWallet,
            xDisconnectWallet,
            xClose,
            xStake,
            xUnStake,
            send,
        },
    }
}
